module.exports = __webpack_public_path__ + "static/img/helpful.8fb6617f.png";